export const gapi = "https://backsafenat.samm-sas.net/api/";
// export const gapi = 'http://localhost:8000/api/';